module.exports = __webpack_public_path__ + "img/icon-5.ed31fa09.svg";